import useSWR from "swr";
import MonthYearPicker from "../../MonthYearPicker";
import useMonthYear from "../../MonthYearPicker/useMonthYear";
import moment from "moment";
import apiClient from "../../../apiClient";
import VirtualTable from "../../custom/VirtualTable";
import styled from "styled-components";
import ActionIcon from "../../custom/ActionIcon";
import { getMinutes, timeSince } from "../../../utils";

const fetcher = async (endpoint: string) => {
    try {
        const res = await apiClient.get(endpoint);
        return res.data;
    } catch (err) {
        return [];
    }
}

export default function AssignedTrainingRecords ({
    tableRef,
    handleExportData
}: {
    tableRef: React.MutableRefObject<undefined>;
    handleExportData: (name: string) => void;
}) {

    const now = moment();
    const { month, setMonth, year, setYear } = useMonthYear(now.month(), now.year());
    const {
        data,
        mutate
    } = useSWR(`/getAssignedTraining?month=${month}&year=${year}`, fetcher, {
        fallbackData: []
    });

    const removeTrainingById = async (id: number) => {
        await apiClient.delete(`/removeTrainingById/${id}`);
        mutate();
    }

    return (
        <div>
            <FlexContainer>
                <MonthYearPicker
                    setMonth={setMonth}
                    setYear={setYear}
                />
                <ActionIcon 
                    type='csv'
                    onClick={() => handleExportData(`Assigned Training ${month}-${year}.csv`)}
                />
            </FlexContainer>
            <VirtualTable 
                data={data}
                mapping={[{
                    name: 'Module',
                    value: 's_module_name'
                }, {
                    name: 'Unit',
                    value: 's_unit',
                    customWidth: 100
                }, {
                    name: 'Content Type',
                    value: 's_content_type',
                    customWidth: 150
                }, {
                    name: 'Email',
                    value: 's_user_id'
                }, {
                    name: 'First Name',
                    value: 's_first_name'
                }, {
                    name: 'Last Name',
                    value: 's_last_name'
                }, {
                    name: 'Completed',
                    value: 'b_completed',
                    boolean: true,
                    customWidth: 100
                }, {
                    name: 'Percent',
                    value: 'f_percent',
                    percent: true,
                    customWidth: 100
                }, {
                    name: 'Assigned by',
                    value: 's_assignor',
                    email: true
                }, {
                    name: 'Assigned date',
                    value: 't_created',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Unassign',
                    value: 'fas fa-trash',
                    icon: true,
                    customWidth: 75,
                    showCondition: item => !item.b_completed,
                    function: (item: any) => removeTrainingById(item.id)
                }]}
                reactTableRef={tableRef}
            />
        </div>
    );

}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;